/* global attachEvent, localData */
// **********************************************************
// Ajax for new results to render on search template
// **********************************************************
const search = document.querySelector('.search-result-template #search');
if (search) {
  const loading = document.querySelector('.menu-overlay');
  const moreButton = document.querySelector('.search-result-template .list-module__button');
  const renderMoreResults = () => {
    loading.classList.add('is-visible');
    const offset = document.querySelectorAll('.search-result-block').length;
    const list = document.querySelector('.search-result');
    const term = search.value;
    const request = new XMLHttpRequest();
    request.open('POST', localData.siteURL, true);
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    request.send(`action=getMoreResults&term=${term}&offset=${offset}`);
    request.onreadystatechange = function () {
      if (this.readyState === 4 && this.status === 200) {
        const response = JSON.parse(this.responseText);
        moreButton.hidden = !!response.data.showingAll;
        if (response.data.all) {
          let prodHtml = '';
          response.data.data.forEach((elm) => {
            prodHtml += `<a href="${elm.url}"><div class="search-result-block">
                                        <div class="search-result-block__title : title--h6">
                                            <h3>${elm.title}</h3>
                                        </div>
                                        <div class="search-result-block__url : text--18">
                                            ${elm.url}
                                        </div>
                                        <div class="search-result-block__text : text--18-24lh">
                                            <p>${elm.excerpt}</p>
                                        </div>
                                    </div></a>`;
          });
          list.innerHTML += prodHtml;
          document.querySelector('.result-indicator__text').innerHTML = response.data.showingText;
          document.querySelector('.result-indicator__progress-bar').style.width = `${response.data.barWidth}%`;
        }
        loading.classList.remove('is-visible');
      }
    };
  };
  attachEvent('.search-result-template .list-module__button .btn', 'click', (e) => {
    e.stopPropagation();
    e.preventDefault();
    renderMoreResults();
  });
}
